var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 16.728c.446 0 .814.334.868.765l.007.11v3.523a.874.874 0 01-.765.867l-.11.007h-4.375a.874.874 0 01-.868-.764l-.007-.11v-3.524c0-.445.333-.813.765-.867l.11-.007h4.375zm-7-3.495c.447 0 .814.334.868.764l.007.11v6.99a.874.874 0 01-.765.867l-.11.007H9.875a.874.874 0 01-.868-.764L9 21.097v-6.99c0-.445.333-.813.765-.867l.11-.007h4.375zm-7-5.243c.447 0 .814.334.868.765l.007.11v12.232a.874.874 0 01-.765.867l-.11.007H2.875a.874.874 0 01-.868-.764L2 21.097V8.864c0-.445.333-.813.765-.867l.11-.007H7.25zm13.125 10.486H17.75v1.776h2.625v-1.776zm-7-3.495H10.75v5.243h2.625V14.98zm-7-5.243H3.75v10.486h2.625V9.738zM15.125 1a5.252 5.252 0 015.25 5.243c0 1.263-.454 2.42-1.202 3.325l-.165.19 3.735 3.731a.872.872 0 01-.618 1.492.873.873 0 01-.53-.178l-.089-.078-3.88-3.875a5.252 5.252 0 01-7.752-4.608A5.252 5.252 0 0115.125 1zm0 1.748c-1.93 0-3.5 1.567-3.5 3.495a3.501 3.501 0 007 0 3.501 3.501 0 00-3.5-3.495z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconCompare;